import { v1ApiClient } from '@/services';
import type { Operation, Schema } from '@/shared/api/generated';

type CreateReportOperation = Operation<'CreateReport'>;
type CreateReportBody = {
  dashboard_id: string;
  title: string;
  items: Record<string, unknown>[];
  rows: Array<{
    alias: string;
    columns: Array<{
      alias: string;
      item_alias: string;
    }>;
  }>;
};

export type CreateReportParams =
  CreateReportOperation['parameters']['path'] & CreateReportBody;

export type CreateReportResponse = Schema<'Report'>;

export const createReport = ({
  workspace_id,
  ...body
}: CreateReportParams): Promise<CreateReportResponse> =>
  v1ApiClient
    .post(`/workspaces/${workspace_id}/reports`, body)
    .then((res) => res.data);
